// extracted by mini-css-extract-plugin
export default {"container":"DataGridWithPagination_container__Gnrut"};